<template>
  <div class="modalbox-content">
    <div class="section-label">Características Físicas</div>
    <v-row>
      <v-col cols="4">
        <div class="form-group">
          <label class="field-label">
            Altura (cm)
            <BadgeErp campo="altura" :camposSincronizados="camposSincronizados" />
          </label>
          <input type="number" class="form-control form-control-sm" v-model="item.altura" />
        </div>
      </v-col>
      <v-col cols="4">
        <div class="form-group">
          <label class="field-label">
            Largura (cm)
            <BadgeErp campo="largura" :camposSincronizados="camposSincronizados" />
          </label>
          <input type="number" class="form-control form-control-sm" v-model="item.largura" />
        </div>
      </v-col>
      <v-col cols="4">
        <div class="form-group">
          <label class="field-label">
            Comprimento (cm)
            <BadgeErp campo="comprimento" :camposSincronizados="camposSincronizados" />
          </label>
          <input type="number" class="form-control form-control-sm" v-model="item.comprimento" />
        </div>
      </v-col>
      <v-col cols="4">
        <div class="form-group">
          <label class="field-label">
            Peso Bruto (kg)
            <BadgeErp campo="pesobruto" :camposSincronizados="camposSincronizados" />
          </label>
          <input type="number" class="form-control form-control-sm" v-model="item.pesobruto" />
        </div>
      </v-col>
      <v-col cols="4">
        <div class="form-group">
          <label class="field-label">
            Peso Líquido (kg)
            <BadgeErp campo="pesoliquido" :camposSincronizados="camposSincronizados" />
          </label>
          <input type="number" class="form-control form-control-sm" v-model="item.pesoliquido" />
        </div>
      </v-col>
      <v-col cols="4">
        <div class="form-group">
          <label class="field-label">
            Volume (m³)
            <BadgeErp campo="volume" :camposSincronizados="camposSincronizados" />
          </label>
          <input type="number" class="form-control form-control-sm" v-model="item.volume" />
        </div>
      </v-col>
      <v-col cols="4">
        <div class="form-group">
          <label class="field-label">
            Unidade
            <BadgeErp campo="unidade" :camposSincronizados="camposSincronizados" />
          </label>
          <input type="text" class="form-control form-control-sm" v-model="item.unidade" />
        </div>
      </v-col>
      <v-col cols="4">
        <div class="form-group">
          <label class="field-label">
            Embalagem (qtd)
            <BadgeErp campo="embalagem" :camposSincronizados="camposSincronizados" />
          </label>
          <input type="number" class="form-control form-control-sm" v-model="item.embalagem" />
        </div>
      </v-col>
      <v-col cols="4">
        <div class="form-group">
          <label class="field-label">Caixa Fechada</label>
          <input type="text" class="form-control form-control-sm" v-model="item.caixafechada" />
        </div>
      </v-col>
    </v-row>

    <div class="section-label">Comercial</div>
    <v-row>
      <v-col cols="4">
        <div class="form-group">
          <label class="field-label">Classe de Venda</label>
          <select class="form-control form-control-sm" v-model="item.classe_venda">
            <option v-for="opt in classeVendaOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
          </select>
        </div>
      </v-col>
      <v-col cols="4">
        <div class="form-group">
          <label class="field-label">Markup Sugestão (%)</label>
          <input type="number" class="form-control form-control-sm" v-model="item.markup_sugestao" />
        </div>
      </v-col>
      <v-col cols="4">
        <div class="form-group">
          <label class="field-label">Prazo de Troca</label>
          <input type="text" class="form-control form-control-sm" v-model="item.prazotroca" />
        </div>
      </v-col>
      <v-col cols="6">
        <div class="form-group">
          <label class="field-label">Página Catálogo</label>
          <input type="text" class="form-control form-control-sm" v-model="item.pagina_catalogo" />
        </div>
      </v-col>
      <v-col cols="6">
        <div class="form-group">
          <label class="field-label">Site Fornecedor</label>
          <input type="text" class="form-control form-control-sm" v-model="item.site_fornecedor" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BadgeErp from "@/components/BadgeErp";

export default {
  name: "Caracteristicas",
  components: { BadgeErp },
  props: {
    item: { type: Object, required: true },
    camposSincronizados: { type: Array, default: () => [] },
  },
  data() {
    return {
      classeVendaOptions: [
        { value: "", label: "Não definido" },
        { value: "A", label: "Classe A" },
        { value: "B", label: "Classe B" },
        { value: "C", label: "Classe C" },
      ],
    };
  },
};
</script>

<style scoped>
.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 12px 0 8px;
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
}

.form-group {
  margin-bottom: 12px;
}
</style>
